/* Early Black Friday — keeps the "free gifts" flavour card in step with the
   3rd (free) flavour the shopper picks in the 2+1 row. */
(function () {
  'use strict';
  if (location.pathname.indexOf('breathefree-2-0-resistance-necklace-early-black-friday') === -1) return;

  var MYSTERY_LABEL = 'Mystery pick';

  /* the image shown beside the free-flavour select */
  function tileImage(sel) {
    var node = sel;
    for (var i = 0; i < 6 && node; i++) {
      node = node.parentNode;
      if (node && node.querySelector) {
        var img = node.querySelector('img');
        if (img && img.getAttribute('src')) return img.getAttribute('src');
      }
    }
    return null;
  }

  function sync() {
    var sel = document.querySelector('[data-rsb-pick="mystery"]');
    if (!sel) return;
    var value = sel.value || MYSTERY_LABEL;
    var isMystery = value === MYSTERY_LABEL;
    var wantTitle = isMystery ? 'Mystery Flavor Refill' : value;
    var wantSrc = tileImage(sel);

    var cards = document.querySelectorAll('.rsb .rsb-gift');
    for (var i = 0; i < cards.length; i++) {
      var t = cards[i].querySelector('.rsb-gift__t');
      if (!t) continue;
      var txt = (t.textContent || '').trim();
      var isFlavourCard = cards[i].getAttribute('data-ebf-free') === '1' ||
                          /mystery flavor refill/i.test(txt);
      if (!isFlavourCard) continue;

      cards[i].setAttribute('data-ebf-free', '1');

      /* only write when it would actually change, so the observer settles */
      if (txt !== wantTitle) t.textContent = wantTitle;

      var gi = cards[i].querySelector('.rsb-gift__img img');
      if (gi && wantSrc && gi.getAttribute('src') !== wantSrc) {
        gi.setAttribute('src', wantSrc);
        gi.setAttribute('alt', wantTitle);
      }
      break;
    }
  }

  function start() {
    sync();
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-rsb-pick="mystery"]')) {
        setTimeout(sync, 0);
      }
    });
    var root = document.querySelector('[data-rsb]');
    if (root) new MutationObserver(function () { sync(); }).observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
